import { render, staticRenderFns } from "./editProjectModal.vue?vue&type=template&id=9f1633dc&scoped=true"
import script from "./editProjectModal.vue?vue&type=script&lang=js"
export * from "./editProjectModal.vue?vue&type=script&lang=js"
import style0 from "./editProjectModal.vue?vue&type=style&index=0&id=9f1633dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1633dc",
  null
  
)

export default component.exports